<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <button class="btn btn-primary mb-4" @click="addNew">add new message</button>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان فارسی</th>
                    <th>عنوان انگلیسی</th>
                    <th>متن فارسی</th>
                    <th>متن انگلیسی</th>
                    <!-- <th>وضعیت</th> -->
                    <th>تاریخ ساخت</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="message in messages" :key="message._id">
                    <td>{{ message.title }}</td>
                    <td>{{ message.titleEn }}</td>
                    <td>{{ message.text }}</td>
                    <td>{{ message.textEn }}</td>
                    <!-- <td>{{ message.isAvailable ? 'فعال' : 'غیر فعال' }}</td> -->
                    <td>{{ new Date(message.createdAt).toLocaleString('fa-IR') }}</td>
                    <td>
                      <button @click="edit(message)" class="btn btn-gradient-03 mr-3">مشاهده</button>
                      <button @click="deleteMessage(message)" class="btn btn-gradient-01">حذف</button>
                    </td>
                    <!--  <td>
                      <router-link :to="{ path: '/dashboard/license', query: { id: license._id } }">مشاهده</router-link>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <!-- disabled -->
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getMessages({ page: page.pre })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getMessages({ page: page.next })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
    <AddEdit :modal="modalData" @clicked="addEdit"></AddEdit>
  </div>
</template>

<script>
import messageService from '../../../../services/messageService.js';
export default {
  components: {
    AddEdit: () => import('./modal.vue'),
  },

  created() {
    this.getMessages({ page: 1 });
  },

  data() {
    return {
      messages: [],
      modalData: {},
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
    };
  },

  methods: {
    async getMessages({ page = 1 }) {
      try {
        if (page == '' || parseInt(page) < 1) return;
        const instance = new messageService();
        console.log(page);
        const res = await instance.getPublicMessages({ page });
        this.pageController(res);
        this.messages = res.messages;
      } catch (err) {
        console.log(err);
      }
    },

    addNew() {
      this.modalData = {};
      window.$('#message-pub').modal('show');
    },

    edit(message) {
      this.modalData = message;
      window.$('#message-pub').modal('show');
    },

    async addEdit(message) {
      try {
        const instance = new messageService();
        if (message._id) {
          await instance.updateMessagee(message);
          // edit
        } else {
          // create
          await instance.creatMessage(message);
        }
        window.$('#message-pub').modal('hide');
        this.getMessages({ page: 1 });
      } catch (err) {
        console.log(err);
      }
    },

    async deleteMessage(message) {
      try {
        const instance = new messageService();
        await instance.deleteMessage(message._id);
        this.getMessages({ page: 1 });
      } catch (err) {
        console.log(err);
      }
    },
    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
  },
};
</script>
